export default __webpack_public_path__ + "static/media/Nicki_9781408325124.b8f9df56.jpg";